// Hook utworzenia kalkulacji jako KOPIA istniejacej -
// POST /sales-crm/clients/:cid/offers/:oid/positions/:pid/calculations/from-template

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferCalculationFromTemplatePayload {
  sourceCalculationId: number;
}

export type IPostSalesCrmOfferCalculationFromTemplateResponse = ICommandResponseSuccess & {
  id?: number;
  name?: string;
};

const postSalesCrmOfferCalculationFromTemplate = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPostSalesCrmOfferCalculationFromTemplatePayload
): Promise<IPostSalesCrmOfferCalculationFromTemplateResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/calculations/from-template`,
    payload
  );

export const usePostSalesCrmOfferCalculationFromTemplate = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<
    IPostSalesCrmOfferCalculationFromTemplateResponse,
    IError,
    IPostSalesCrmOfferCalculationFromTemplatePayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmOfferCalculationFromTemplatePayload) =>
      postSalesCrmOfferCalculationFromTemplate(clientId, offerId, positionId, payload),
    options
  );
